// @flow
import { AsyncRequest } from 'angieslist-app-platform';
import { combineReducers } from 'redux';
import performanceActionKeys from './performanceActionKeys';
import type {
  GetContactMetricsByServiceProviderRequest,
  GetContactMetricsByServiceProviderResponse,
  GetContactMetricsCategoryGroupsByServiceProviderRequest,
  GetContactMetricsCategoryGroupsByServiceProviderResponse,
  GetCallLogByServiceProviderRequest,
  GetCallLogByServiceProviderResponse,
  CustomerAttributesRequest,
  CustomerAttributesResponse,
} from './performanceService';
import type { AsyncState } from '../../../app/types';

export type GetContactMetricsByServiceProviderState =
  AsyncState<GetContactMetricsByServiceProviderRequest, GetContactMetricsByServiceProviderResponse>;

export type GetCategoryContactMetricsByServiceProviderState =
  AsyncState<GetContactMetricsCategoryGroupsByServiceProviderRequest,
  GetContactMetricsCategoryGroupsByServiceProviderResponse>;

export type getCallLogByServiceProviderState =
  AsyncState<GetCallLogByServiceProviderRequest, GetCallLogByServiceProviderResponse>;

export type getCustomerAttributesByUuidState =
  AsyncState<CustomerAttributesRequest, CustomerAttributesResponse>;

export const contactMetrics: any =
  AsyncRequest.createReducer(performanceActionKeys.GET_CONTACT_METRICS_BY_SERVICE_PROVIDER);

export const
  contactMetricsByCategory: any = AsyncRequest
    .createReducer(performanceActionKeys.GET_CONTACT_METRICS_CATEGORY_GROUPS_BY_SERVICE_PROVIDER);

export const callLog: any =
  AsyncRequest.createReducer(performanceActionKeys.GET_CALL_LOG_BY_SERVICE_PROVIDER);

export const customerAttributes: any =
  AsyncRequest.createReducer(performanceActionKeys.GET_CUSTOMER_ATTRIBUTES_BY_UUID);

export type PerformanceReducerState = {
  contactMetrics: GetContactMetricsByServiceProviderState,
  customerAttributes: getCustomerAttributesByUuidState
}

export type GroupPerformanceReducerState = {
  contactMetricsByCategory: GetCategoryContactMetricsByServiceProviderState
}

export type CallLogReducerState = {
  callLog: getCallLogByServiceProviderState
}

export default (combineReducers({
  contactMetrics,
  contactMetricsByCategory,
  callLog,
  customerAttributes,
}): any);



// WEBPACK FOOTER //
// ./src/modules/home/common/performanceReducer.js